/*
 * Farida Gupta - open product card links in a new tab on desktop (theme/snippets/product-card.liquid).
 *
 * Only the image and title links should behave this way, and only once past the theme's desktop
 * breakpoint (the "md" media query in snippets/js-variables.liquid, 1024px) - below that (mobile/
 * tablet) they keep navigating in the same tab as normal. A plain left-click is the only case
 * intercepted; ctrl/cmd/shift/middle-click already open a new tab/window natively so those are left
 * alone to avoid double-opening.
 */
const desktopMediaQuery = window.matchMedia('screen and (min-width: 1024px)');

document.addEventListener('click', (event) => {
  if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
  if (!desktopMediaQuery.matches) return;

  const link = event.target.closest('product-card a.product-card__media, product-card a.product-title');

  if (!link) return;

  event.preventDefault();
  window.open(link.href, '_blank', 'noopener');
});
